import Vue from "vue";

Vue.filter("shorten", function(str, len) {
  if (!str) return "";
  let r = str.substring(0, len);
  if (str.length > len) {
    r += "\u2026";
  }
  return r;
});

Vue.filter("dateDDMMYYYY", function(stringDate) {
  if (!stringDate) return "";
  const fecha = new Date(stringDate);
  const day = ("0" + fecha.getDate()).slice(-2).toString();
  const month = ("0" + (fecha.getMonth() + 1)).slice(-2).toString();
  const year = fecha.getFullYear();
  return day + "-" + month + "-" + year;
});

Vue.filter("dateDDMMYYYYhhmm", function(stringDate) {
  if (!stringDate) return "";
  const fecha = new Date(stringDate);
  const day = ("0" + fecha.getDate()).slice(-2).toString();
  const month = ("0" + (fecha.getMonth() + 1)).slice(-2).toString();
  const year = fecha.getFullYear();
  const hour = ("0" + (fecha.getHours() - 1)).slice(-2).toString();
  const minutes = ("0" + fecha.getMinutes()).slice(-2).toString();
  return day + "-" + month + "-" + year + " " + hour + ":" + minutes;
});

Vue.filter("currencyEUR", function(dataCurrency) {
  if (!dataCurrency) return "";

  const importe = dataCurrency.toFixed(2).replace(/./g, function(c, i, a) {
    return i && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
  });
  return importe + "\u20AC";
});

Vue.filter("numericFormat", function(dataCurrency) {
  if (!dataCurrency) return "";

  const data = dataCurrency.toFixed(2).replace(/./g, function(c, i, a) {
    return i && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
  });
  return data;
});
